<template>
<div class="bg-white px-3 py-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
  <el-button type="primary" plain size="mini" @click="settingModel = true">{{$t('msg.DATA리셋')}}</el-button>
   <el-tabs v-model="activeName" @tab-click="handleClick">
    <el-tab-pane label="settings-1" v-if="this.power=='1'"  name="first">
       <div style="position:relative;z-index: 100;margin-top: 10px;">
         <span class="mr-2 text-center" style="width:152px;display: inline-block;">{{$t('status.알본선택')}}:</span><el-select v-model="admin_id"  style="width: 100px;" size="medium" @change="adminChange($event)">
               <el-option
                      v-for="item in adminlist"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select> 
      </div>
      <div class="d-flex" v-loading="loading" style="margin-top:5px; flex-direction: column;">
       
        <div class="d-flex" >
           <el-table
           :row-class-name="tableRowClassName1"
           border
              :data="btnDataOne"       
               style="width: 100%"
               class="mt-2"
               :empty-text="$t('tableText.데이타가없습니다')">
               
                 <el-table-column
                  prop="game_name" align="center">
                <template slot-scope="scope">
                  <div class="d-flex align-items-center">
                     <span class="mr-2" style="width:150px;">{{scope.row.game_name}}</span><el-input v-model="scope.row.game_rate" style="width:200px"></el-input>
                  </div>
                  </template>
              </el-table-column> 

            </el-table>
             <el-table
              :data="btnDataTwo"
               :row-class-name="tableRowClassName1"
                border
               style="width: 100%"
               class="mt-2"
               :empty-text="$t('tableText.데이타가없습니다')">
               
                 <el-table-column
                  prop="game_name" align="center">
                <template slot-scope="scope">
                  <div class="d-flex align-items-center">
                     <span class="mr-2" style="width:150px;">{{scope.row.game_name}}</span><el-input v-model="scope.row.game_rate" style="width:200px"></el-input>
                  </div>
                  </template>
              </el-table-column> 

            </el-table>
         <el-table
              :data="btnDataThree"
               :row-class-name="tableRowClassName1"
           border
               style="width: 100%"
               class="mt-2"
               :empty-text="$t('tableText.데이타가없습니다')">
               
                 <el-table-column
                  prop="game_name" align="center">
                <template slot-scope="scope">
                  <div class="d-flex align-items-center">
                     <span class="mr-2" style="width:150px;">{{scope.row.game_name}}</span><el-input v-model="scope.row.game_rate" style="width:200px"></el-input>
                  </div>
                  </template>
              </el-table-column> 

            </el-table>

            <el-table
              :data="btnDataFour"
               style="width: 100%"
                :row-class-name="tableRowClassName1"
           border
               class="mt-2"
               :empty-text="$t('tableText.데이타가없습니다')">
               
                 <el-table-column
                  prop="game_name" align="center">
                <template slot-scope="scope">
                  <div class="d-flex align-items-center">
                     <span class="mr-2" style="width:150px;">{{scope.row.game_name}}</span><el-input v-model="scope.row.game_rate" style="width:200px"></el-input>
                  </div>
                  </template>
              </el-table-column> 

            </el-table>
    </div>
    
    <div class="d-flex" style="flex-direction: column;">
      <div class="text-center mt-2 text-primary" style="z-index:100;font-size: 16px;"></div>
      <div class="d-flex" style="margin-top:-30px;">
         <el-table
              :data="btnDataOne1"       
               style="width: 100%"
                :row-class-name="tableRowClassName1"
                 border
               class="mt-2"
               :empty-text="$t('tableText.데이타가없습니다')">
               
                 <el-table-column
                  prop="game_name" align="center">
                <template slot-scope="scope">
                  <div class="d-flex align-items-center">
                     <span class="mr-2" style="width:150px;">{{scope.row.game_name}}</span><el-input v-model="scope.row.game_rate" style="width:200px"></el-input>
                  </div>
                  </template>
              </el-table-column> 

            </el-table>
             <el-table
              :data="btnDataTwo1"
               style="width: 100%"
                :row-class-name="tableRowClassName1"
                 border
               class="mt-2"
               :empty-text="$t('tableText.데이타가없습니다')">
               
                 <el-table-column
                  prop="game_name" align="center">
                <template slot-scope="scope">
                  <div class="d-flex align-items-center">
                     <span class="mr-2" style="width:150px;">{{scope.row.game_name}}</span><el-input v-model="scope.row.game_rate" style="width:200px"></el-input>
                  </div>
                  </template>
              </el-table-column> 

            </el-table>
         <el-table
              :data="btnDataThree1"
               :row-class-name="tableRowClassName1"
                 border
               style="width: 100%"
               class="mt-2"
               :empty-text="$t('tableText.데이타가없습니다')">
               
                 <el-table-column
                  prop="game_name" align="center">
                <template slot-scope="scope">
                  <div class="d-flex align-items-center">
                     <span class="mr-2" style="width:150px;">{{scope.row.game_name}}</span><el-input v-model="scope.row.game_rate" style="width:200px"></el-input>
                  </div>
                  </template>
              </el-table-column> 

            </el-table>

            <el-table
              :data="btnDataFour1"
               style="width: 100%"
               class="mt-2"
                :row-class-name="tableRowClassName1"
                 border
               :empty-text="$t('tableText.데이타가없습니다')">
               
                 <el-table-column
                  prop="game_name" align="center">
                <template slot-scope="scope">
                  <div class="d-flex align-items-center">
                     <span class="mr-2" style="width:150px;">{{scope.row.game_name}}</span><el-input v-model="scope.row.game_rate" style="width:200px"></el-input>
                  </div>
                  </template>
              </el-table-column> 
            </el-table>
      </div>
      
    </div>

</div>
<div class="mt-3 text-center"><el-button type="primary" @click="settings"  :disabled="disabled">{{$t('msg.확인')}}</el-button></div>
    </el-tab-pane>
    <el-tab-pane label="settings-2" v-if="this.power=='1'" name="second">
    
   <div style="position:relative;z-index: 100;margin-top: 10px;">
         <span class="mr-2 text-center" style="width:152px;display: inline-block;">{{$t('status.알본선택')}}:</span><el-select v-model="admin_id"  style="width: 100px;" size="medium" @change="adminChange($event)">
               <el-option
                      v-for="item in adminlist"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select> 
                <span class="text-danger" style="margin-left:10px">{{$t('msg.최소배팅')}}|{{$t('msg.최대배팅')}}|{{$t('msg.회차당토탈최대배팅')}}</span>
      </div>
      <div v-loading="loading" style="margin-top:10px; flex-direction: column;" class="d-flex">
    <div  class="d-flex">
   <el-table
      :data="powerbet"       
       style="width: 100%"
       class="mt-2"
        :row-class-name="tableRowClassName1"
         border
       :empty-text="$t('tableText.데이타가없습니다')">
         <el-table-column
          prop="wr_1" align="center">
        <template slot-scope="scope">
          <div class="d-flex align-items-center">
             <span class="mr-2" style="width:150px;">{{scope.row.mname}}</span>
            
              <el-input style="width:200px" v-model="scope.row.wr_3"></el-input>
            

             
          </div>
          </template>
      </el-table-column> 

    </el-table>
    <el-table
      :data="powerGroupBet"       
       style="width: 100%"
        :row-class-name="tableRowClassName1"
         border
       class="mt-2"
       :empty-text="$t('tableText.데이타가없습니다')">
         <el-table-column
          prop="wr_1" align="center">
        <template slot-scope="scope">
          <div class="d-flex align-items-center">
             <span class="mr-2" style="width:150px;">{{scope.row.mname}}</span><el-input v-model="scope.row.wr_3" style="width:200px"></el-input>
          </div>
          </template>
      </el-table-column> 

    </el-table>
     <el-table
      :data="sadariBet"       
       style="width: 100%"
        :row-class-name="tableRowClassName1"
         border
       class="mt-2"
       :empty-text="$t('tableText.데이타가없습니다')">
         <el-table-column
          prop="wr_1" align="center">
        <template slot-scope="scope">
          <div class="d-flex align-items-center">
             <span class="mr-2" style="width:150px;">{{scope.row.mname}}</span><el-input v-model="scope.row.wr_3" style="width:200px"></el-input>
          </div>
          </template>
      </el-table-column> 

    </el-table>
    <el-table
      :data="sadarigroupBet"       
       style="width: 100%"
        :row-class-name="tableRowClassName1"
         border
       class="mt-2"
       :empty-text="$t('tableText.데이타가없습니다')">
         <el-table-column
          prop="wr_1" align="center">
        <template slot-scope="scope">
          <div class="d-flex align-items-center">
             <span class="mr-2" style="width:150px;">{{scope.row.mname}}</span><el-input v-model="scope.row.wr_3" style="width:200px"></el-input>
          </div>
          </template>
      </el-table-column> 

    </el-table>
</div>
 <div  class="d-flex">
   <el-table
      :data="powerbet1"       
       style="width: 100%"
        :row-class-name="tableRowClassName1"
         border
       class="mt-2"
       :empty-text="$t('tableText.데이타가없습니다')">
         <el-table-column
          prop="wr_1" align="center">
        <template slot-scope="scope">
          <div class="d-flex align-items-center">
             <span class="mr-2" style="width:150px;">{{scope.row.mname}}</span>
            
              <el-input style="width:200px" v-model="scope.row.wr_3"></el-input>
            

             
          </div>
          </template>
      </el-table-column> 

    </el-table>
    <el-table
      :data="powerGroupBet1"       
       style="width: 100%"
        :row-class-name="tableRowClassName1"
         border
       class="mt-2"
       :empty-text="$t('tableText.데이타가없습니다')">
         <el-table-column
          prop="wr_1" align="center">
        <template slot-scope="scope">
          <div class="d-flex align-items-center">
             <span class="mr-2" style="width:150px;">{{scope.row.mname}}</span><el-input v-model="scope.row.wr_3" style="width:200px"></el-input>
          </div>
          </template>
      </el-table-column> 

    </el-table>
     <el-table
      :data="sadariBet1"       
       style="width: 100%"
        :row-class-name="tableRowClassName1"
         border
       class="mt-2"
       :empty-text="$t('tableText.데이타가없습니다')">
         <el-table-column
          prop="wr_1" align="center">
        <template slot-scope="scope">
          <div class="d-flex align-items-center">
             <span class="mr-2" style="width:150px;">{{scope.row.mname}}</span><el-input v-model="scope.row.wr_3" style="width:200px"></el-input>
          </div>
          </template>
      </el-table-column> 

    </el-table>
    <el-table
      :data="sadarigroupBet1"       
       style="width: 100%"
        :row-class-name="tableRowClassName1"
         border
       class="mt-2"
       :empty-text="$t('tableText.데이타가없습니다')">
         <el-table-column
          prop="wr_1" align="center">
        <template slot-scope="scope">
          <div class="d-flex align-items-center">
             <span class="mr-2" style="width:150px;">{{scope.row.mname}}</span><el-input v-model="scope.row.wr_3" style="width:200px"></el-input>
          </div>
          </template>
      </el-table-column> 

    </el-table>
</div>

  </div>
  <div class="mt-3 text-center"><el-button type="primary" @click="settings" :disabled="disabled">{{$t('msg.확인')}}</el-button></div>
    </el-tab-pane>
    <el-tab-pane label="settings-3" name="third">
      <div style="position:relative;z-index: 100;margin-top: 10px;">
         <span class="mr-2 text-center" style="width:152px;display: inline-block;">{{$t('status.알본선택')}}:</span>
         <el-select v-model="admin_id"  style="width: 100px;" size="medium" @change="adminChange($event)">
               <el-option
                      v-for="item in adminlist"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select> 
      </div>
      <div class="d-flex" v-loading="loading" style="margin-top:10px;">
       
           <el-table
              :data="sets"  
               :row-class-name="tableRowClassName1"
         border     
               style="width: 100%"
               class="mt-2"
               :empty-text="$t('tableText.데이타가없습니다')">
                 <el-table-column
                  prop="wr_1" align="center">
                <template slot-scope="scope">
                 
                     
                  <div class="d-flex align-items-center">

                     <span class="mr-2" style="width:150px;">{{scope.row.mname}}</span>
                     <template v-if="scope.row.input ==='1' ">
                         

                         <template v-if="scope.row.files !='1' ">
                        <el-input style="width:400px" v-model="scope.row.wr_2"></el-input>
                        <el-checkbox v-if="scope.row.wr_1=='loginmemo'" true-label="1" false-label="0" v-model="scope.row.wr_3" class="ml-2">
                          <strong>{{$t('msg.사용')}}</strong>
                        </el-checkbox>

                         </template>

                         <template v-else="">
                        <el-input style="width:400px"  v-model="scope.row.wr_3" readonly></el-input>
                         <el-button icon="el-icon-video-play" type="text" class="playIcon" @click="play(scope)"></el-button>
                          <audio id="setAudio"></audio>
                        <el-checkbox  true-label="1" false-label="0" v-model="scope.row.wr_2" class="ml-2">
                          <strong>{{$t('msg.사용')}}</strong>
                        </el-checkbox>
                       
                         <el-button size="small"  type="primary" plain @click="selectFile(scope)" class="ml-2">{{$t('msg.업로드')}}</el-button> 
                          <input type="file"   ref="selectFile" name="wenjian" @change="checkFile($event)"  style="display:none;"/>
                         
                       
                         </template>

                     </template>


                    

                     <template v-else-if="scope.row.input ==='0'">
                        <el-checkbox true-label="1" false-label="0" v-model="scope.row.wr_2"></el-checkbox>
        
                     </template>
                      <template v-else-if="scope.row.input ==='3' ">
                      <el-select v-model="scope.row.wr_2"  style="width: 120px;margin-left: 0px;" size="medium" >
                         <el-option
                                v-for="item in softlist"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                              </el-option>
                        </el-select> 
                      </template>

                        <template v-else-if="scope.row.input ==='4' ">
                      <el-select v-model="scope.row.wr_2"  style="width: 120px;margin-left: 0px;" size="medium" >
                         <el-option
                                v-for="item in apilist"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                              </el-option>
                        </el-select> 
                      </template>

                     {{scope.row.unit}}
                    

                     
                  </div>
                  </template>
              </el-table-column> 

            </el-table>
   
  </div>
  <div class="mt-3 text-center"><el-button type="primary" @click="settings" :disabled="disabled">{{$t('tableText.수정')}}</el-button></div>
    </el-tab-pane>
    <el-tab-pane label="settings-4" name="fourth">
    
<div style="position:relative;z-index: 100;margin-top: 10px;">
         <span class="mr-2 text-center" style="width:152px;display: inline-block;">{{$t('status.알본선택')}}:</span><el-select v-model="admin_id"  style="width: 100px;" size="medium" @change="adminChange($event)">
               <el-option
                      v-for="item in adminlist"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select> 
              <span class="ml-2">체크해재하시면 사이트에 노출이안됩니다</span>
      </div>
      <div v-loading="loading">
        <div class="d-flex" style="flex-wrap: wrap;"  >
          <div v-for="(item,index) in gamep" :key="index" style="width:150px;" class="border-bottom border-right text-center py-1">
            
              <p>{{item.title_name}} <el-checkbox  true-label="1" false-label="0" v-model="item.dis" class="ml-2"></el-checkbox></p>
               <el-radio-group v-model="item.server_stop">
                          <el-radio label="0">{{$t('msg.정상')}}</el-radio>
                          <el-radio label="1">{{$t('msg.점검')}}</el-radio>       
               </el-radio-group>
            
          </div>

      

        </div>
         <div class="d-flex" style="flex-wrap: wrap;margin-top:40px"  >
         <div v-for="(item,index) in gameslot"  style="width:150px" class="border-bottom border-right text-center py-1">
            
              <p>{{item.title_name}} <el-checkbox  true-label="1" false-label="0" v-model="item.dis" class="ml-2"></el-checkbox></p>
               <el-radio-group v-model="item.server_stop">
                          <el-radio label="0">{{$t('msg.정상')}}</el-radio>
                          <el-radio label="1">{{$t('msg.정검')}}</el-radio>       
               </el-radio-group>
            
          </div>
      </div></div>
       <div class="mt-3 text-center"><el-button type="primary" @click="settings4" :disabled="disabled">{{$t('msg.확인')}}</el-button></div>
     
    </el-tab-pane>
      <el-tab-pane label="settings-5" name="fifth">
        
        <table class="table table-bordered settings5"  v-loading="loading" >
          <tr v-for="(item,index) in gamep2" :key="index">
            <th>
              {{item.title_name}}
            </th>
            <td>
                <div class="d-flex" style="flex-wrap: wrap;">
                    <div v-for="(item2,index) in item.detail" :key="index" style="width:200px" class="border-bottom border-right text-center py-1">
                      
                        <p>{{item2.game_title}}</p>
                         <el-radio-group v-model="item2.is_stop">
                                    <el-radio label="0">{{$t('msg.정상')}}</el-radio>
                                    <el-radio label="1">{{$t('msg.정검')}}</el-radio>       
                         </el-radio-group>
                      
                    </div>
                  </div>
            </td>
          </tr>
        </table>
        <div class="mt-3 text-center"><el-button type="primary" @click="settings5" :disabled="disabled">{{$t('msg.확인')}}</el-button></div>
      </el-tab-pane>
    
  </el-tabs>

 
     <div style="height: 100px;"></div>
     <!-- Model -->
    <el-dialog 
          :visible.sync="settingModel" width="25%" :title="$t('msg.데이타삭제')" :close-on-click-modal ="false">

          <el-form ref="form" :model="form" label-width="100px" v-loading="loading">
             <el-form-item :label="$t('searchText.구분')" class="mb-0">
              <el-select :placeholder="$t('status.선택')" v-model="type1" class="w-50">
                  <el-option
                  v-for="item in sType1"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
                </el-select>
              <span class="text-muted ml-2" style="margin-top: -3px">{{$t('msg.하부포함')}}</span>  <el-checkbox true-label="1" false-label="0" v-model="habu" style="vertical-align: middle;margin-right:10px !important"></el-checkbox>
               <span class="text-muted mr-2" style="margin-top: -3px">{{$t('msg.하부만')}}</span>  <el-checkbox true-label="1" false-label="0" v-model="onlyhabu" style="vertical-align: middle;"></el-checkbox>
            </el-form-item>
            <el-form-item :label="$t('msg.아이디')" class="mb-0">
              <el-input v-model="form.mem_id"  class="w-50"></el-input>
            </el-form-item>
           
            <el-form-item :label="$t('tableText.타입')" class="mb-0">
              <el-select :placeholder="$t('status.선택')" v-model="type" class="w-50">
                  <el-option
                  v-for="item in sType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('searchText.인증코드')" class="mb-0">
              <el-input v-model="form.code" type="number" :placeholder="$t('searchText.구글OTP')"  class="w-50"></el-input>
            </el-form-item>
         
          </el-form>
          <div class="text-danger text-center mt-1">복구가안되므로 확인후 진행해주세요!!!</div>
          <span slot="footer" class="dialog-footer">
             <el-button @click="settingModel = false">{{$t('msg.취소')}}</el-button>
            <el-button type="primary" @click="settingSumbit">{{$t('msg.확인')}}</el-button>
          </span>
        
       
       
        </el-dialog>                 
      
        
</div>
 </template>

 <script>

 export default {
      data(){
        return{
          habu:0,
          onlyhabu:0,
          scope:null,
          admin_id:'',
          adminlist:[{
               label:this.$i18n.t("status.선택"),
                value:''
            },
            
            ],
          settingModel:false,
          type:'',
          sType: [
              {
                label:this.$i18n.t("msg.입금"),
                 value: '1',
               
              }, {
                label:this.$i18n.t("msg.출금"),
                 value: '2',
               
              }, {
                label: this.$i18n.t("msg.입출금"),
                 value: '3',
               
              }, {
                label:this.$i18n.t("msg.전체"),
                 value: '7',
               }
              ],
           type1:'',
            softlist: [
              {
                label:this.$i18n.t("msg.전체파싱"),
                 value: '1',
               
              }, {
                label:this.$i18n.t("msg.개별파싱"),
                 value: '2',
               
              }, {
                label: this.$i18n.t("msg.전체정품"),
                 value: '3',
               
              }
              ],
                apilist: [
              {
                label:"SD",
                 value: 'sd',
               
              },{
                label:"오라클",
                 value: 'sp',
               
              },{
                label:"아너",
                 value: 'hn',
               
              },{
                label:"S밴더",
                 value: 'ss',
               
              }, {
                label:this.$i18n.t("msg.개별설정"),
                 value: 'user',
               
              }
              ],
           soft_id:'',
          sType1: [
              {
                label:this.$i18n.t("msg.회원"),
                 value: 'mem_id',
               
              }, {
                label:this.$i18n.t("msg.매장"),
                 value: 'c_code',
               
              }, {
                label: this.$i18n.t("msg.총판"),
                 value: 'a_code',
               
              }, {
                label:this.$i18n.t("msg.부본"),
                 value: 'b_code',
               }, {
                label:this.$i18n.t("msg.본사"),
                 value: 's_code',
               }
              ],
          domain:window.sessionStorage.getItem('domain'),
           sitetype:window.sessionStorage.getItem('sitetype'),
            bg:window.sessionStorage.getItem('bg'),
            power:window.sessionStorage.getItem('power'),
             activeName: 'first',
             loading: false,
             btnDataOne: [],
             btnDataTwo:[],
             btnDataThree:[],
             btnDataFour:[],
             gamep:[],
              gameslot:[],
            gamep2:[],

             btnDataOne1: [],
             btnDataTwo1:[],
             btnDataThree1:[],
             btnDataFour1:[],

             powerbet:[],
             powerGroupBet:[],
             sadariBet:[],
             sadarigroupBet:[],

             powerbet1:[],
             powerGroupBet1:[],
             sadariBet1:[],
             sadarigroupBet1:[],


             sets:[],
             marset:[],
             tapidx:"0",
             tabname:'',
             disabled:false,
             form:{
                mem_id:'',
                code:'',
              },

          }
          
          
        },
        created() {
           let token=window.sessionStorage.getItem('user');
           this.$axios({
                  method:'get',
                  url:this.domain+'/admin/bubonlist_select?type=bossnull&admin=1',
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
    
            }).then((response) =>{ 
              
           let newids=[];

            let obj={};
            obj.label=this.$i18n.t("msg.없음")
            obj.value=''
            newids.push(obj); 

            newids=[];

            


            response.data.admin.forEach(item=>{
            let obj={};
            obj.label=item.name
            obj.value=item.name
            newids.push(obj);            
           });


           

           this.adminlist=newids
    
            }).catch((error) =>{
              
            })
          

          this.getList();

        if(this.sitetype=="3")
        {
                this.sType=[
               {
                 label:this.$i18n.t("msg.입금"),
                 value: '1',
               
              }, {
                label:this.$i18n.t("msg.출금"),
                 value: '2',
               
              }, {
                label:this.$i18n.t("msg.입출금"),
                 value: '3',
               
              }, {
               label:this.$i18n.t("msg.파워볼배팅"),
                 value: '4',
               
              }, {
                label: this.$i18n.t("msg.레이스배팅"),
                 value: '5',
               
              }, {
                label:this.$i18n.t("msg.전체"),
                 value: '7',
               
              }
              ];
        }

        if(this.sitetype=="1")
        {
                this.sType=[
              {
                label:this.$i18n.t("msg.입금"),
                 value: '1',
               
              }, {
                label:this.$i18n.t("msg.출금"),
                 value: '2',
               
              }, {
                label:this.$i18n.t("msg.입출금"),
                 value: '3',
               
              }, {
                label:this.$i18n.t("msg.파워볼배팅"),
                 value: '4',
               
              }, {
                 label:this.$i18n.t("msg.전체"),
                 value: '7',
               
              }
              ];
        }

        if(this.sitetype=="2")
        {
                this.sType=[
               {
                label: this.$i18n.t("msg.입금"),
                 value: '1',
               
              }, {
                label:this.$i18n.t("msg.출금"),
                 value: '2',
               
              }, {
                label:this.$i18n.t("msg.입출금"),
                 value: '3',
               
              }, {
                label: this.$i18n.t("msg.레이스배팅"),
                 value: '5',
               
              }, {
                label:this.$i18n.t("msg.전체"),
                 value: '7',
               
              }
              ];
        }

        if(this.sitetype=="4")
        {
                this.sType=[
               {
                label: this.$i18n.t("msg.입금"),
                 value: '1',
               
              }, {
                label: this.$i18n.t("msg.출금"),
                 value: '2',
               
              }, {
                label: this.$i18n.t("msg.입출금"),
                 value: '3',
               
              }, {
                label: this.$i18n.t("msg.배팅"),
                 value: '8',
               
              }, {
                label: this.$i18n.t("msg.전체"),
                 value: '7',
               
              }
              ];
        }

          
      
    },
 
      methods:{
         play(v) {
          //在这给音频 赋值 地址
          //  this.$refs.audio.src("test.mp3");
            //this.$refs.audio.play();

            console.log('vvv',v);

            var setAudio = document.getElementById('setAudio');
            setAudio.src=""+v.row.wr_3;
            setAudio.play();
          },
       selectFile (id) {
        console.log(id)
        this.scope=id
   
    this.$refs.selectFile.click()  // 这样就会触发 文件的选择
},
        checkFile(e) {

          console.log(e);
        
          let token=window.sessionStorage.getItem('user');
          let file = e.target.files[0]
          const formData = new FormData()
          formData.append('file', file)
          this.$axios({
　　　　　　　　　　url: this.domain+'/admin/filemp3',
　　　　　　　　　　method: 'post',
                  'Accept': 'application/json',
                  headers: { 'Authorization': 'Bearer ' + token },
　　　　　　　　　　data: formData,
　　　　　　　　　
　　　　　　　　}).then((url) => {
                    this.$message.success(this.$i18n.t("msg.업로드완료"))
                    console.log('url:',url.data.data)
                    this.scope.row.wr_3= url.data.data
                     
                            　　　　　　　　　　
　　　　　　　　　
　　　　　　　　}).catch(err => {
          console.error(err)
        })

    
    },
             adminChange(v){

                console.log(v)
                this.admin_id=v

                this.getList()

              },
            stringCut(money) {
              let money1 = money.split("|")
              return money1
            },
            
              handleClick(tab, event) {
              this.tabname=tab.name
              this.tapidx=tab.index
              this.getList()
      },
       tableRowClassName1({row, rowIndex}) {
                 
                   if (rowIndex%2 === 1) {
                    return 'odd-row-class';
                   }
                   else{
                     return 'edd-row-class';
                   }
                },

        settings(){


          this.disabled = true
          this.loading = true
          let token=window.sessionStorage.getItem('user');
          let datas=[];

          //console.log(this.tabname);


         

          let urlidx="0";

          if(this.tabname=="first")
          {
             datas=[this.btnDataOne,this.btnDataTwo,this.btnDataThree,this.btnDataFour,this.btnDataOne1,this.btnDataTwo1,this.btnDataThree1,this.btnDataFour1]
             urlidx="0";
            // console.log('')
            
          }else if(this.tabname=="second")
          {
            datas=[this.powerbet,this.powerGroupBet,this.sadariBet,this.sadarigroupBet,this.powerbet1,this.powerGroupBet1,this.sadariBet1,this.sadarigroupBet1]
            urlidx="1";
          }
          else if(this.tabname=="third")
          {
              datas=this.sets
              urlidx="2";
              let sound='';

              this.sets.forEach(function(element) {
             if(element["wr_1"]=="inss")
             {
                 sound=sound+element["wr_3"]+"-";
             }
             if(element["wr_1"]=="outss")
             {
                sound=sound+element["wr_3"]+"-";
             }
             if(element["wr_1"]=="qass")
             {
                sound=sound+element["wr_3"]+"-";
             }
             if(element["wr_1"]=="joinss")
             {
                sound=sound+element["wr_3"]+"";
             }
             });
              //음성파일수정
                window.sessionStorage.setItem('sound',sound)
          }
          else if(this.tabname=="fourth")
          {
              datas=this.marset
              urlidx="3";
          }
          else if(this.tabname=="")
          {
             datas=[this.btnDataOne,this.btnDataTwo,this.btnDataThree,this.btnDataFour,this.btnDataOne1,this.btnDataTwo1,this.btnDataThree1,this.btnDataFour1]
             urlidx="0";
          }

          

         
           this.$axios({
                      method:'post',
                      url:this.domain+'/admin/set_up'+urlidx+'?admin_id='+this.admin_id, 
                      data:datas,
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 


                   if(response.data.code==200){
                       
                       this.$message({
                          message:response.data.msg,
                          type:'success'
                      })   
                       
                    }else
                    {
                        this.$message.error(response.data.msg);
              
                    }
                    this.getList()
                    this.loading = false
                    this.disabled = false
                   
                  }).catch((error) =>{

                     this.$message.error(error);
                     this.loading = false
                     this.disabled = false

                     // console.log(error)       //请求失败返回的数据
                  })
          
          
          
         
            
         
        },
         settings4(){
          this.disabled = true
          this.loading = true
          let token=window.sessionStorage.getItem('user');


          //let newarr=this.gamep.concat(this.gameslot);
         
           this.$axios({
                      method:'post',
                      url:this.domain+'/admin/set_up4?admin_id='+this.admin_id, 
                      data:{
                        live:this.gamep,
                        slot:this.gameslot
                      },
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 


                   if(response.data.code==200){
                       
                       this.$message({
                          message:response.data.msg,
                          type:'success'
                      })   
                       
                    }else
                    {
                        this.$message.error(response.data.msg);
              
                    }
                    this.getList()
                    this.loading = false
                    this.disabled = false
                   
                  }).catch((error) =>{

                     this.$message.error(error);
                     this.loading = false
                     this.disabled = false

                     // console.log(error)       //请求失败返回的数据
                  })
          
          
          
         
            
         
        },
         settings5(){
          this.disabled = true
          this.loading = true
          let token=window.sessionStorage.getItem('user');
         
           this.$axios({
                      method:'post',
                      url:this.domain+'/admin/set_up5?admin_id='+this.admin_id, 
                      data:this.gamep2,
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 


                   if(response.data.code==200){
                       
                       this.$message({
                          message:response.data.msg,
                          type:'success'
                      })   
                       
                    }else
                    {
                        this.$message.error(response.data.msg);
              
                    }
                    this.getList()
                    this.loading = false
                    this.disabled = false
                   
                  }).catch((error) =>{

                     this.$message.error(error);
                     this.loading = false
                     this.disabled = false

                     // console.log(error)       //请求失败返回的数据
                  })
          
          
          
         
            
         
        },
        settingSumbit(){
          let token=window.sessionStorage.getItem('user');
           this.loading = true
              this.$axios({
                    method:'post',
                    url:this.domain+'/admin/reset_ac',
                    data:{
                      mem_id:this.form.mem_id,
                      code:this.form.code,
                      type:this.type,
                      level:this.type1,
                      habu:this.habu,
                     onlyhabu:this.onlyhabu
                    },
                    'Accept': 'application/json',
                     headers: { 'Authorization': 'Bearer ' + token },
      
              }).then((response) =>{ 
                   
                
                     this.loading = false
                    let item = response.data.data
                  //  console.log('data==',item)
                    if(response.data.code==200){
                    

                     this.form.mem_id=''
                     this.form.code=''
                       this.settingModel = false
                       this.$message({
                          message:response.data.msg,
                          type:'success'
                      })   
                    }else
                    {
                       this.$message({
                          message:response.data.msg,
                          type:'error'
                      })   
                    }
                    
                     
                
                 
              }).catch((error) =>{
                  console.log(error)       //请求失败返回的数据
              })
        },

        getList(){

         
              
          this.loading = true
           let token=window.sessionStorage.getItem('user');
            //console.log(token);
           let urls=this.domain+'/admin/settings?admin_id='+this.admin_id;

          this.$axios({
                  method:'get',
                  url:urls,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
                
               
            }).then((response) =>{ 

                     console.log('tableData=',response.data.data)
                     let item = response.data.data
                     this.btnDataOne =item.btn1
                     this.btnDataTwo =item.btn2
                     this.btnDataThree =item.btn3
                     this.btnDataFour=item.btn4





                     if(this.power=='1')
                     {
                           this.powerbet = item.power_bet
                           this.powerGroupBet = item.power_group_bet
                           this.sadariBet = item.sadari_bet
                           this.sadarigroupBet = item.sadari_group_bet
                     }


                     
                    

                     this.sets = item.set
                     this.marset = item.marset
                     this.gamep = item.gamep
                     this.gameslot = item.gameslot
                     this.gamep2 = item.gamep2
                     this.loading =false
               
            }).catch((error) =>{
             
               this.$message.error(error);
              this.loading = false
                //console.log('error',error.response)       //请求失败返回的数据
               
            })
        },
    
          
    
      }
  }
</script>

 <style scoped>
.settings5 tr th{
  background: #f1f1f1;
  width: 200px;
  text-align: center;
  vertical-align: middle;
}
.settings5 td{
  padding: 0;
}
>>>.el-table th.el-table__cell.is-leaf{
  display:none;
}
</style>


// WEBPACK FOOTER //
// src/views/settings/list.vue